import AsyncComponent from './AsyncComponent';

export default AsyncComponent;
